export default {
    es: {
        onboarding: {
            headline: "Desbloquea el poder de las finanzas autónomas",
            subtitleSetup: "Completemos tu configuración",
            subtitleDone: "Aprovecha KIPLAN",
            personal: {
                title: "Cuéntanos sobre ti",
                firstName: "Nombre *",
                lastName: "Apellido *",
                email: "Correo",
                username: "Nombre de usuario",
                skip: "Omitir",
                next: "Siguiente",
                saveError: "No se pudo guardar la información personal"
            },
            companyInfo: {
                alreadyMember: "Ya eres parte de una empresa",
                company: "Empresa:",
                taxId: "NIT:",
                notAvailable: "N/A",
                skip: "Omitir",
                continue: "Continuar"
            },
            companyChoice: {
                title: "Configura tu empresa",
                createTab: "Crear Nueva Empresa",
                joinTab: "Unirse a una Empresa"
            },
            createCompany: {
                companyName: "Nombre de la Empresa *",
                companyNameRequired: "El nombre de la empresa es obligatorio",
                taxId: "NIT / ID Fiscal",
                country: "País",
                numberOfEmployees: "Número de Empleados",
                skip: "Omitir",
                createButton: "Crear Empresa",
                createError: "No se pudo crear la empresa"
            },
            joinCompany: {
                loading: "Cargando invitaciones...",
                noPending: "No tienes invitaciones pendientes.",
                askAdmin: "Pide a un administrador que te invite con tu correo.",
                refresh: "Actualizar",
                skip: "Omitir",
                fetchError: "No se pudieron cargar las invitaciones",
                acceptError: "No se pudo aceptar la invitación"
            },
            done: {
                title: "¡Todo listo!",
                subtitle: "Estás listo para empezar a usar la plataforma.",
                enterButton: "Entrar a Kiplan"
            }
        },
    },
    en: {
        onboarding: {
            headline: "Unlock the power of autonomous finance",
            subtitleSetup: "Let's complete your setup",
            subtitleDone: "Take advantage of KIPLAN",
            personal: {
                title: "Tell us about yourself",
                firstName: "First Name *",
                lastName: "Last Name *",
                email: "Email",
                username: "Username",
                skip: "Skip",
                next: "Next",
                saveError: "Failed to save personal info"
            },
            companyInfo: {
                alreadyMember: "You're already part of a company",
                company: "Company:",
                taxId: "Tax ID:",
                notAvailable: "N/A",
                skip: "Skip",
                continue: "Continue"
            },
            companyChoice: {
                title: "Set up your company",
                createTab: "Create New Company",
                joinTab: "Join Existing Company"
            },
            createCompany: {
                companyName: "Company Name *",
                companyNameRequired: "Company name is required",
                taxId: "Tax ID",
                country: "Country",
                numberOfEmployees: "Number of Employees",
                skip: "Skip",
                createButton: "Create Company",
                createError: "Failed to create company"
            },
            joinCompany: {
                loading: "Loading invitations...",
                noPending: "You have no pending invitations.",
                askAdmin: "Ask a company admin to invite you using your email.",
                refresh: "Refresh",
                skip: "Skip",
                fetchError: "Failed to load invitations",
                acceptError: "Failed to accept invitation"
            },
            done: {
                title: "All set!",
                subtitle: "You're ready to start using the platform.",
                enterButton: "Enter Kiplan"
            }
        },
    },
}
